import { useEffect, useState } from "react";
import PediPlayPageHeader from "../../Shared/UI/PediplayPageHeader";
import ReportTable from "./TherapistIFSPTable";
import { Button, Col, Row, Select, Tabs, Tooltip } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { GetIFSPReportsByTherapist } from "../../Shared/Services";
import { useCurrentUser } from "../../Shared/Contexts/UserContext";
import { exportToCSV } from "../../Shared/Functions";
import { iconSize } from "../../Shared/UI/jsx";

const TherapistIFSP = props => {
    const user = useCurrentUser();

    const current = dayjs();
    const [month, setMonth] = useState(current.month() + 1);
    const [year, setYear] = useState(current.year());
    const [activeTab, setActiveTab] = useState("0");

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const [highlighted, setHighlighted] = useState();

    const fetchReport = () => {
        setLoading(true);

        GetIFSPReportsByTherapist(user.therapistId ? user.therapistId : 0, month, year)
            .then((res) => {
                setData(res.data);
                setHighlighted(res.data[0]);
            })
            .finally(() => {
                setLoading(false);
            })
    };

    useEffect(() => {
        if(user?.therapistId) {
            fetchReport();
        }
    }, [user, month, year]);

    const filteredData = 
        Number(activeTab) === 0
            ? data
            : data?.filter((r) => r.monthsDue === Number(activeTab)) ?? [];

    const handleRowOnClick = record => {
        setHighlighted(record);
    }

    const extra = (
        <div style={{ textAlign: 'end' }}>
            <Tooltip title="Export" placement="top">
                <Button
                    type="link"
                    icon={<ExportOutlined style={iconSize} />}
                    onClick={() => exportToCSV(`IFSPReports-${user.userName}`, data)}
                />    
            </Tooltip>
        </div>
    );

    const monthOptions = Array.from({ length: 12 }, (_, i) => ({
        label: dayjs().month(i).format("MMMM"),
        value: i + 1,
    }));

    const yearOptions = Array.from({ length: 11 }, (_, i) => {
        const y = current.year() - 5 + i;
        return { label: y, value: y };
    });

    return (
        <div>
            <Row gutter={[8,8]}>
                <Col span={24}>
                    <PediPlayPageHeader
                        title={'Therapist IFSP Reports'}
                        props={props}
                        loading={loading}
                        extra={extra}
                    />
                </Col>
                <Col span={24}>
                    <Row gutter={12}>
                        <Col>
                            <Select
                                value={month}
                                onChange={setMonth}
                                options={monthOptions}
                                style={{ width: 160 }}
                            />    
                        </Col>
                        <Col>
                            <Select
                                value={year}
                                onChange={setYear}
                                options={yearOptions}
                                style={{ width: 120 }}
                            />    
                        </Col>
                    </Row>
                </Col>
                <Col span={24}>
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={[
                            { key: "0", label: "All Reports" },
                            { key: "5", label: "5-Month Reports" },
                            { key: "10", label: "10-Month Reports" }
                        ]}
                    />    
                </Col>
                <Col span={24}>
                        <div
                            style={{
                                padding: "12px 16px",
                                background: "#fafafa",
                                borderRadius: 6,
                                border: "1px solid #e8e8e8",
                                marginBottom: 12,
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: 16,
                                fontWeight: 500
                            }}
                        >
                            <div>5-Month Reports: {data?.filter(r => r.monthsDue === 5).length}</div>
                            <div>10-Month Reports: {data?.filter(r => r.monthsDue === 10).length}</div>
                            <div>Total: {data?.length}</div>
                        </div>    
                </Col>
                <Col span={24}>
                    <ReportTable reports={filteredData} loading={loading} highlighted={highlighted} handleRowOnClick={handleRowOnClick} />
                </Col>
            </Row>
        </div>
    );
}

export default TherapistIFSP;